import { get, isEmpty } from 'lodash-es';
import { call, put, select, takeLatest, take } from 'redux-saga/effects';
import {
	setActionLoaderFalse,
	setActionLoaderTrue,
} from '../../reducers/actionLoader';
import { resetActionError, setActionError } from '../../reducers/actionError';
import { fetch_market_watch_data } from '../../../apis/equity/sessionLess/marketWatch';
import {
	MARKET_WATCH_SCREENER_KEY,
	STOCK_LANDING_MW_PAYLOAD,
} from '../../../constants/landingComponents/stockLanding/marketWatch';
import { PULL_REFRESH_STATE } from '../../../constants/common';
import {
	fetchMarketWatchData,
	fetchMarketWatchGuestScripDetail,
	getStockLandingMarketWatchList,
	setMarketWatchData,
	setMarketWatchPullRefreshState,
	setStockLandingMarketWatchData,
} from '../../reducers/equity/marketWatch';
import { getMarketWatchTokenList } from '../../../utils/landingComponents/stockLanding/marketWatch';
import { fetchScripDetailList } from '../../reducers/equity/guestLogin';

export default function* sagaOrderBook() {
	yield takeLatest(
		fetchMarketWatchData.toString(),
		handleFetchMarketWatchData,
	);
	yield takeLatest(
		fetchMarketWatchGuestScripDetail.toString(),
		handleFetchMarketWatchGuestScripDetail,
	);
}

function* handleFetchMarketWatchData({ payload = {} }) {
	const {
		segment = '',
		screenerKeys = [],
		indexName = '',
		isPullToRefresh,
		isGuestScripApiAllowed = false,
		Api,
		sessionLessServer,
	} = payload;
	const body = {
		segment: segment,
		screener_keys: screenerKeys,
		indexname: indexName,
		expiry: '-',
		instrument: '-',
	};
	try {
		yield put(setActionLoaderTrue(fetchMarketWatchData));
		yield put(resetActionError(fetchMarketWatchData));
		const response = yield call(
			fetch_market_watch_data,
			Api,
			sessionLessServer,
			body,
		);
		const marketWatchResponse = get(response, 'data', {});
		const isNiftyFiftySelected =
			indexName === STOCK_LANDING_MW_PAYLOAD.indexName;
		const data = {
			indexName,
			data: marketWatchResponse,
		};
		if (isNiftyFiftySelected) {
			yield put(setStockLandingMarketWatchData(data));
		}
		yield put(setMarketWatchData(data));
		if (isPullToRefresh) {
			yield put(
				setMarketWatchPullRefreshState({
					[PULL_REFRESH_STATE.IS_SUCCESS]: true,
				}),
			);
		}
		if (isGuestScripApiAllowed) {
			yield put(
				fetchMarketWatchGuestScripDetail({
					marketWatchApiData: response,
					isGuestApiAllowed: true,
				}),
			);
		}
	} catch (error) {
		console.log('error from handleFetchMarketWatchData is', error.message);
		yield put(
			setActionError({
				actionName: fetchMarketWatchData,
				isFetchFailed: true,
				message: error.message,
			}),
		);
		const defaultErrorPayload = {
			[MARKET_WATCH_SCREENER_KEY.gainers]: [],
			[MARKET_WATCH_SCREENER_KEY.losers]: [],
			[MARKET_WATCH_SCREENER_KEY.weekHigh]: [],
			[MARKET_WATCH_SCREENER_KEY.weekLow]: [],
		};
		const data = {
			indexName,
			data: defaultErrorPayload,
		};
		yield put(setMarketWatchData(data));
		if (isPullToRefresh) {
			yield put(
				setMarketWatchPullRefreshState({
					[PULL_REFRESH_STATE.IS_FAILED]: true,
				}),
			);
		}
	} finally {
		yield put(setActionLoaderFalse(fetchMarketWatchData));
	}
}

function* handleFetchMarketWatchGuestScripDetail({ payload = {} }) {
	const { marketWatchApiData = {}, isGuestApiAllowed = false, Api } = payload;
	try {
		let marketWatchResponse = yield select(getStockLandingMarketWatchList);
		if (!isEmpty(marketWatchApiData)) {
			marketWatchResponse = marketWatchApiData;
		}
		let marketWatchData = get(marketWatchResponse, 'data', {});
		if (!isGuestApiAllowed) return;
		if (isEmpty(marketWatchData)) {
			const takeMarketWatchResponse = yield take(
				setMarketWatchData.toString(),
			);
			marketWatchData = get(takeMarketWatchResponse, 'payload.data', {});
		}
		const marketWatchTokenList = getMarketWatchTokenList(
			marketWatchData,
			isGuestApiAllowed,
		);

		yield put(
			fetchScripDetailList({
				scripTokenList: marketWatchTokenList,
				screen: '',
				isGuestApiAllowed,
				Api,
			}),
		);
	} catch (err) {
		console.log(
			'error from handleFetchMarketWatchGuestScripDetail is',
			err.message,
		);
	}
}
